module.exports = __webpack_public_path__ + "assets/img/00034.7e7c4086.png";